   
                           
  
                                                   
                          
   

import MD5 from 'md5-es';

let globalSerial = 1;

export default class UnicornCrypto {
  static is = 'crypto';

  static install(app, options = {}) {
    const $crypto = app.$crypto = new this(app, options);

    app.base64Encode = $crypto.base64Encode.bind($crypto);
    app.base64Decode = $crypto.base64Decode.bind($crypto);
    app.uuid4 = $crypto.uuid4.bind($crypto);
    app.uid = $crypto.uid.bind($crypto);
    app.tid = $crypto.tid.bind($crypto);
    app.md5 = $crypto.md5.bind($crypto);
    app.serial = $crypto.serial.bind($crypto);
  }

  constructor(app, options = {}) {
    this.app = app;
    this.$options = options;
  }

     
                   
    
                           
    
                      
     
  base64Encode(string) {
    return btoa(String(string))
      .replace(/\+/, '-')
      .replace(new RegExp('\\/'), '_')
      .replace(/=+$/, '');
  }

     
                   
    
                           
    
                      
     
  base64Decode(string) {
    return atob(
      String(string)
        .replace(/-/, '+')
        .replace(/_/, '/')
    );
  }

     
                        
    
                        
                         
     
  encrypt(key, data) {
    const code = data.split('').map((c, i) => c.charCodeAt(0) ^ this.keyCharAt(key, i)).join(',');

    return this.base64Encode(code);
  }

     
                        
    
                        
                         
    
                      
     
  decrypt(key, data) {
                                                 
    data = this.base64Decode(data);

                                                 
    data = data.split(',');

    return data.map((c, i) => String.fromCharCode(c ^ this.keyCharAt(key, i))).join('');
  }

     
                 
    
                        
                      
    
                      
     
  keyCharAt(key, i) {
    return key.charCodeAt(Math.floor(i % key.length));
  }

     
            
    
                                             
    
                      
     
  uuid4() {
    return (function b(a) {
      return a ? (a ^ Math.random() * 16 >> a / 4).toString(16) : ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, b);
    }());
  }

     
                                                  
    
                            
                              
                      
     
  uid(prefix = '', timebase = false) {
    if (timebase) {
      const start = performance?.timeOrigin
        ? Math.round(performance.timeOrigin)
        : performance.timing.navigationStart;

      const time = (start * 100000) + (performance.now() * 100);

      return prefix + time.toString(12) + (this.randomString(4));
    }

    return prefix + this.randomString(12);
  }

     
                            
                      
     
  tid(prefix = '') {
    return this.uid(prefix, true);
  }

     
                      
                      
     
  randomString(n = 12) {
    const QUOTA = 65536;
    const crypto = (window.crypto || window.msCrypto);

    if (!crypto) {
      return Math.floor(Math.random() * (n ** 10));
    }

    const a = new Uint8Array(n);

    for (let i = 0; i < n; i += QUOTA) {
      crypto.getRandomValues(a.subarray(i, i + Math.min(n - i, QUOTA)));
    }

    return [...a]
      .map(x => x.toString(16).padStart(2, '0'))
      .join('');
  }

     
                        
                      
     
  md5(str) {
    return MD5.hash(str);
  }

     
                      
     
  serial() {
    return globalSerial++;
  }
}
